import React from "react";
import "./ProviderEducationDegreeModal.css";
import {
  Form,
  Input,
  Modal,
  Row,
  Col,
  Button,
  Skeleton,
  DatePicker,
} from "antd";
import { Trans } from "@lingui/macro";
import { nameofFactory } from "../../../utils";
import {
  NewProviderEducationDegree,
  hideNewProviderEducationDegreeModal,
  ProviderEducationDegreeState,
} from "../../../store/providerEducationDegree";
import { ProviderEducationDegreeModalProps } from "./Types";
import { useSelector, useDispatch } from "react-redux";

const FormStateless: React.FC<ProviderEducationDegreeModalProps> = (props) => {
  const { MonthPicker } = DatePicker;
  const { form, onCreate, showModal } = props;
  const { providerEducationDegreeState } = useSelector(mapState);
  const { getFieldDecorator, validateFields } = form;
  const dispatch = useDispatch();

  const newProviderEducationDegreeNameOf = nameofFactory<
    NewProviderEducationDegree
  >();

  const onModalDismiss = () => {
    dispatch(hideNewProviderEducationDegreeModal());
  };

  const onSubmit = () => {
    validateFields((err, values) => {
      if (err) {
        return;
      }

      const request = {
        ...values,
      };

      onCreate(request);
    });
  };

  return (
    <React.Fragment>
      <Modal
        centered
        className="provider-modal"
        destroyOnClose
        visible={showModal}
        footer={
          <Row type="flex" justify="end" gutter={16}>
            <Col>
              <Button
                loading={
                  providerEducationDegreeState.updatingProviderEducationDegree
                }
                onClick={onSubmit}
                type="primary"
              >
                <Trans
                  render="span"
                  id="ProviderEducationDegreeModal.CreateButton"
                >
                  Create
                </Trans>
              </Button>
            </Col>
            <Col>
              <Button
                disabled={
                  providerEducationDegreeState.updatingProviderEducationDegree
                }
                onClick={onModalDismiss}
              >
                <Trans
                  render="span"
                  id="ProviderEducationDegreeModal.CancelButton"
                >
                  Cancel
                </Trans>
              </Button>
            </Col>
          </Row>
        }
        onCancel={onModalDismiss}
        title={
          <Trans id="ProviderEducationDegreeModal.CreateFormTitle">
            Create degree
          </Trans>
        }
      >
        <Skeleton
          loading={providerEducationDegreeState.updatingProviderEducationDegree}
        >
          <Form colon={false}>
            <Row type="flex" gutter={16}>
              <Col span={24}>
                <Form.Item
                  label={
                    <Trans id="ProviderEducationDegreeModal.ProfessionalDegreeNameLabel">
                      Name
                    </Trans>
                  }
                >
                  {getFieldDecorator(
                    newProviderEducationDegreeNameOf(
                      "ProviderEducationDegreeTitle"
                    ),
                    {
                      rules: [
                        {
                          required: true,
                          message: <Trans id="Common.RequiredFieldError" />,
                        },
                      ],
                    }
                  )(
                    <Input
                      name={newProviderEducationDegreeNameOf(
                        "ProviderEducationDegreeTitle"
                      )}
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row type="flex" gutter={16}>
              <Col span={24}>
                <Form.Item
                  label={
                    <Trans id="ProviderEducationDegreeModal.DegreeInstituteNameLabel">
                      Institute name
                    </Trans>
                  }
                >
                  {getFieldDecorator(
                    newProviderEducationDegreeNameOf(
                      "ProviderEducationDegreeInstituteName"
                    ),
                    {
                      rules: [
                        {
                          required: true,
                          message: <Trans id="Common.RequiredFieldError" />,
                        },
                      ],
                    }
                  )(
                    <Input
                      name={newProviderEducationDegreeNameOf(
                        "ProviderEducationDegreeInstituteName"
                      )}
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row type="flex" gutter={16}>
              <Col span={12}>
                <Form.Item
                  label={
                    <Trans id="ProviderEducationDegreeModal.ProviderEducationDegreeDateFromLabel">
                      Date from
                    </Trans>
                  }
                >
                  {getFieldDecorator(
                    newProviderEducationDegreeNameOf(
                      "ProviderEducationDegreeDateFrom"
                    ),
                    {
                      rules: [
                        {
                          required: false,
                          message: <Trans id="Common.RequiredFieldError" />,
                        },
                      ],
                    }
                  )(<MonthPicker />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={
                    <Trans id="ProviderEducationDegreeModal.ProviderEducationDegreeDateToLabel">
                      Date to
                    </Trans>
                  }
                >
                  {getFieldDecorator(
                    newProviderEducationDegreeNameOf(
                      "ProviderEducationDegreeDateTo"
                    ),
                    {
                      rules: [
                        {
                          required: false,
                          message: <Trans id="Common.RequiredFieldError" />,
                        },
                      ],
                    }
                  )(<MonthPicker />)}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Skeleton>
      </Modal>
    </React.Fragment>
  );
};

const mapState = (state: any): State => ({
  providerEducationDegreeState: state.providerEducationDegreeState,
});

interface State {
  providerEducationDegreeState: ProviderEducationDegreeState;
}

export default Form.create<ProviderEducationDegreeModalProps>()(FormStateless);
